import { locales } from "./locale-provider";
export var staticLang = {
  current: 'en-US'
};
var formatMessage = function formatMessage(props) {
  var locale = locales[staticLang.current] || locales['en-US'];
  var id = props.id,
    values = props.values;
  if (!values || !Object.keys(values).length) {
    return locale[id] || id;
  }
  return (locale[id] || id).replaceAll(/\{(.+?)\}/g, function (_, name) {
    return values[name];
  });
};
export default formatMessage;